"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DelayNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    if (!data) return false;
    let parsed = Number(data.delay.toString());
    return !isNaN(parsed) && parsed > 0;
  }
}
exports.DelayNodeValidation = DelayNodeValidation;
//# sourceMappingURL=DelayNodeValidation.js.map
